// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');
require('@js/swiper');
require('@js/aos');
require('@js/tabs');
require('@js/parallax');
require('@js/photo-swipe');
require('@js/header');
require('@js/ajax-projects');
